import cpfIsValid from './cpf'

const LEGACY_MIN_LENGTH = 5
const LEGACY_MAX_LENGTH = 10
const CPF_LENGTH = 11

function cleaner(value) {
  return String(value ?? '')
    .toUpperCase()
    .replace(/[\s.\-/]/g, '')
}

function isSequential(value) {
  const digits = value.split('').map(Number)

  const isAscending = digits.every((digit, index) => (
    index === 0 || digit === digits[index - 1] + 1
  ))
  const isDescending = digits.every((digit, index) => (
    index === 0 || digit === digits[index - 1] - 1
  ))

  return isAscending || isDescending
}

function validate(value) {
  const cleanRg = cleaner(value)

  if (!cleanRg) {
    return false
  }

  // Aceita apenas digitos, com "X" opcional somente como digito verificador final.
  if (!/^[0-9]+X?$/.test(cleanRg)) {
    return false
  }

  // Novo padrao nacional (CIN/RG unificado): o numero do documento e o CPF.
  if (cleanRg.length === CPF_LENGTH) {
    return cpfIsValid(cleanRg)
  }

  if (cleanRg.length < LEGACY_MIN_LENGTH || cleanRg.length > LEGACY_MAX_LENGTH) {
    return false
  }

  // Rejeita apenas placeholders obvios: todos os caracteres iguais
  // ou sequencia estritamente crescente/decrescente de digitos.
  if (/^(.)\1+$/.test(cleanRg)) {
    return false
  }

  if (!cleanRg.includes('X') && isSequential(cleanRg)) {
    return false
  }

  return true
}

export default validate
